enum InterestPostedOnType {
    FirstDayOfEveryMonth = 1,
    EveryDay = 2,
    EveryWeek = 3,
    EveryMonth = 4,
    EveryThreeMonths = 5,
    EverySixMonths = 6,
    EveryYear = 7,
    Maturity = 8,
}
export default InterestPostedOnType